export function initDragScroll() {
  if (window.__dragScrollInit) return;
  window.__dragScrollInit = true;
  let el = null;
  let startX = 0;
  let startLeft = 0;
  let moved = false;

  const findScrollable = (t) => {
    let n = t instanceof Element ? t : null;
    while (n) {
      if (n.classList?.contains("overflow-x-auto") && n.scrollWidth > n.clientWidth + 5) return n;
      n = n.parentElement;
    }
    return null;
  };

  document.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    if (e.target.closest("button, a, input, textarea, select, [role='switch'], [role='checkbox'], [contenteditable='true']")) return;
    const s = findScrollable(e.target);
    if (!s) return;
    el = s;
    startX = e.clientX;
    startLeft = s.scrollLeft;
    moved = false;
  });

  document.addEventListener("mousemove", (e) => {
    if (!el) return;
    const dx = e.clientX - startX;
    if (Math.abs(dx) > 5) moved = true;
    if (moved) {
      el.scrollLeft = startLeft - dx;
      el.style.cursor = "grabbing";
      el.style.userSelect = "none";
      e.preventDefault();
    }
  });

  document.addEventListener("mouseup", () => {
    if (el) {
      el.style.cursor = "";
      el.style.userSelect = "";
    }
    if (moved) {
      const suppress = (ev) => {
        ev.stopPropagation();
        ev.preventDefault();
        document.removeEventListener("click", suppress, true);
      };
      document.addEventListener("click", suppress, true);
      setTimeout(() => document.removeEventListener("click", suppress, true), 50);
    }
    el = null;
    moved = false;
  });
}
